import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { createSettlement, getSettlementDropdown, getSettlementBalance } from "../../store/ducks/settlement/actions";
import { formValidation, filterErrorHandler } from "../../hoc/Shared/utility";
import Swal from "sweetalert2";
import Button from "../../components/Button/Button";
import ValidationError from "../../components/ValidationError/ValidationError";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import StringInput from "../../components/Input/StringInput/StringInput";
import Select from "../../components/Input/Select/Select";
import Skeleton from "react-loading-skeleton";

const base_currency = {
    1: 'myr',
    4: 'idr'
};

class SettlementCreate extends Component {
    constructor(props){
        super(props);
        this.state = {
            amount: '',
            payment_gateway: '',
            dropdown: [],
            fees: {},
            total_balance: 0,
            total_balance_breakdown: [],
            bank_code: '',
            bank_account_name: '',
            bank_account_no: '',
            touched: false,
            error_message: [],
            loading: true
        }
        this.changeInputHandler = this.changeInputHandler.bind(this);
    }

    componentDidMount(){
        formValidation("settlement_form");
        let data = {};
        this.props.getSettlementDropdown(data);
    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.settlement_dropdown !== undefined && nextProps.settlement_dropdown !== this.props.settlement_dropdown){
            if(nextProps.settlement_dropdown.responseCode === 200 && nextProps.settlement_dropdown.msgType === 'success'){
                let newFees = Object.assign({}, this.state.fees);
                nextProps.settlement_dropdown.data.result.forEach((val, idx) => {
                    if (nextProps.settlement_dropdown.data.fees[val.value] !== undefined) {
                        newFees[val.value] = nextProps.settlement_dropdown.data.fees[val.value];
                    }
                    else {
                        newFees[val.value] = 0;
                    }
                });

                this.setState({
                    loading: false,
                    dropdown: nextProps.settlement_dropdown.data.result,
                    fees: newFees
                });
            }
            else {
                this.setState({
                    loading: true,
                    amount: 0,
                    payment_gateway: '',
                    dropdown: [],
                    balance_breakdown: [],
                    touched: false,
                    error_message: [],
                    fees: {}
                }, () => {
                    filterErrorHandler(nextProps.settlement_dropdown.message);
                });
            }
        }

        if(nextProps.settlement_balance !== undefined && nextProps.settlement_balance !== this.props.settlement_balance){
            if(nextProps.settlement_balance.responseCode === 200 && nextProps.settlement_balance.msgType === 'success'){
                this.setState({
                    touched: false,
                    total_balance: nextProps.settlement_balance.data.total_balance,
                    total_balance_breakdown: nextProps.settlement_balance.data.total_balance_breakdown
                });
            }
            else {
                this.setState({
                    touched: true,
                    error_message: nextProps.settlement_balance.message,
                    total_balance: 0,
                    total_balance_breakdown: []
                });
            }
        }

        if(nextProps.settlement_create !== undefined && nextProps.settlement_create !== this.props.settlement_create){
            if(nextProps.settlement_create.responseCode === 200 && nextProps.settlement_create.msgType === 'success'){
                this.setState({ touched: false });
                const { t } = this.props;
                Swal.fire({
                    title: t("global.record-saved"),
                    icon: nextProps.settlement_create.msgType,
                    confirmButtonText: t("global.ok"),
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.props.refreshHandler();
                        this.props.changePageHandler("listing");
                    }
                });
            }
            else {
                this.setState({
                    touched: true,
                    error_message: nextProps.settlement_create.message,
                });
                Swal.close();
            }
        }

        return true;
    }

    createSettlementHandler = (e) => {
        e.preventDefault();
        const { t } = this.props;
        Swal.fire({
            title: t("global.confirmation"),
            // text: t("global.are-you-sure"),
            html: t('settlement.settlement-confirmation', {fees: this.state.fees[this.state.payment_gateway], currency: t(`global.currency.${base_currency[this.props.currentUser.country_id]}`)}),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: t("global.confirm"),
            cancelButtonText: t("global.cancel"),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });

                let data = {};
                data.payment_gateway = this.state.payment_gateway;
                data.amount = this.state.amount;
                data.balance = this.state.total_balance;
                data.bank_code = this.state.bank_code;
                data.bank_account_name = this.state.bank_account_name;
                data.bank_account_no = this.state.bank_account_no;
                this.props.createSettlement(data);
            }
        });
    }

    changeInputHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        }, () => {
            if(e.target.id === 'payment_gateway'){
                let data = {};
                data.payment_gateway = e.target.value;
                this.props.getSettlementBalance(data);
            }
        });
    }

    render(){
        const { t } = this.props;
        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <h4 className="content-title mb-0 my-auto ml-2">{t("settlement.settlement")}</h4>
                        </div>
                    </div>
                </div>
                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("settlement.new-settlement")}</h4>
                            </div>

                            {this.state.loading ? (
                            <div className="card-body pt-0">
                                <Skeleton count={1} />
                            </div>
                            ) : (
                            <div className="card-body pt-0">
                                <form method="post" id="settlement_form" className="form-horizontal" onSubmit={this.createSettlementHandler} noValidate>
                                    <ValidationError formName="settlement_form" touched={this.state.touched} message={this.state.error_message} />
                                    <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="amount">{t("settlement.bank-code")}</label>
                                                <StringInput
                                                    id="bank_code"
                                                    name="bank_code"
                                                    type="text"
                                                    value={this.state.bank_code}
                                                    onChange={this.changeInputHandler}
                                                    className="form-control filter-input"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="amount">{t("settlement.bank-account-name")}</label>
                                                <StringInput
                                                    id="bank_account_name"
                                                    name="bank_account_name"
                                                    type="text"
                                                    value={this.state.bank_account_name}
                                                    onChange={this.changeInputHandler}
                                                    className="form-control filter-input"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="amount">{t("settlement.bank-account-no")}</label>
                                                <StringInput
                                                    id="bank_account_no"
                                                    name="bank_account_no"
                                                    type="text"
                                                    value={this.state.bank_account_no}
                                                    onChange={this.changeInputHandler}
                                                    className="form-control filter-input"
                                                />
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className='form-group'>
                                                <label>{t('settlement.account-to-settle')}</label>
                                                <Select
                                                    id='payment_gateway'
                                                    name='payment_gateway'
                                                    className='form-control'
                                                    getOptionValue='value'
                                                    getOptionLabel='label'
                                                    options={this.state.dropdown}
                                                    onChange={this.changeInputHandler}
                                                    value={this.state.payment_gateway}
                                                    emptyValue={true}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="amount">{t("settlement.amount-to-settle")}</label>
                                                <NumberInput
                                                    id="amount"
                                                    name="amount"
                                                    min={1}
                                                    max={this.state.total_balance}
                                                    step="0.01"
                                                    placeholder={t("settlement.amount")}
                                                    value={this.state.amount}
                                                    onChange={this.changeInputHandler}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className='col-12'>
                                            <div className="form-group">
                                                <div>
                                                    <label>{t('settlement.total-balance-breakdown')}</label>&nbsp;
                                                    <small style={{color: '#8B0000'}}><b>({t('settlement.settlement-explanation')})</b></small>
                                                </div>
                                                <div className="col-12 border rounded">
                                                    <label style={{fontSize: '16px'}}>
                                                        {t('settlement.total-balance')}: {t(`global.currency.${base_currency[this.props.currentUser.country_id]}`)} {new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(this.state.total_balance)}
                                                    </label>
                                                    <ul id='tree1' className='tree' style={{columns: 1, WebkitColumnCount: 1, MozColumnCount: 1}}>
                                                        {this.state.total_balance_breakdown.length > 0 && (
                                                            <>
                                                                {this.state.total_balance_breakdown.map((val, idx) => {
                                                                    return (
                                                                        <li key={idx}>
                                                                            <label style={{fontSize: '13px'}}>
                                                                                {val.title}: {t(`global.currency.${base_currency[this.props.currentUser.country_id]}`)} {new Intl.NumberFormat('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(val.balance)}
                                                                            </label>
                                                                        </li>
                                                                    );
                                                                })}
                                                            </>
                                                        )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {this.state.total_balance > 0 &&
                                    <div className="form-group mb-0 mt-3 justify-content-end">
                                        <div>
                                            <Button typeButton="submit" classValue="btn btn-blue" idValue="submit" buttonName={t("global.save")} />
                                        </div>
                                    </div>
                                    }
                                </form>
                            </div>
                            )}
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentUser: state.currentUser.data,
        settlement_create: state.settlement.settlement_create,
        settlement_dropdown: state.settlement.settlement_dropdown,
        settlement_balance: state.settlement.settlement_balance
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createSettlement: (data) => dispatch(createSettlement(data)),
        getSettlementDropdown: (data) => dispatch(getSettlementDropdown(data)),
        getSettlementBalance: (data) => dispatch(getSettlementBalance(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(SettlementCreate));